import styled from 'styled-components';

import { setMobileView } from '../tools/mobileView';

export const MainContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    min-height: ${props => props.minHeight ? props.minHeight : ''};

    @media print {
        .printerContainer {
            margin-top: 30px;
            font-size: 12px;
        }
    }
`;

export const ColumnContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.flexDirection ? props.flexDirection : 'column'};
    justify-content: ${props => props.justifyContent ? props.justifyContent : 'center'};
    align-items: ${props => props.alignItems ? props.alignItems : 'center'};
    margin-left: ${props => props.marginLeft ? props.marginLeft : ''};
    margin: ${props => props.margin ? props.margin : ''};
    padding: ${props => props.padding ? props.padding : ''};
    cursor: ${props => props.cursor ? props.cursor : ''};
    height: ${props => props.height ? props.height : ''};
    min-height: ${props => props.minHeight ? props.minHeight : ''};
    width: ${props => props.width ? props.width : ''};
    min-width: ${props => props.minWidth ? props.minWidth : ''};
    max-width: ${props => props.maxWidth ? props.maxWidth : ''};
    border: ${props => props.border ? props.border : ''};
    border-bottom: ${props => props.borderBottom ? props.borderBottom : ''};
`;

export const RowContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.flexDirection ? props.flexDirection : 'row'};
    justify-content: ${props => props.justifyContent ? props.justifyContent : 'center'};
    align-items: ${props => props.alignItems ? props.alignItems : 'center'};
    margin-left: ${props => props.marginLeft ? props.marginLeft : ''};
    margin: ${props => props.margin ? props.margin : ''};
    padding: ${props => props.padding ? props.padding : ''};
    cursor: ${props => props.cursor ? props.cursor : ''};
    height: ${props => props.height ? props.height : ''};
    min-height: ${props => props.minHeight ? props.minHeight : ''};
    width: ${props => props.width ? props.width : ''};
    min-width: ${props => props.minWidth ? props.minWidth : ''};
    max-width: ${props => props.maxWidth ? props.maxWidth : ''};
    border: ${props => props.border ? props.border : ''};
    border-bottom: ${props => props.borderBottom ? props.borderBottom : ''};
`;

export const ContentContainer = styled.div`
    display: flex;
    flex-direction: ${props => props.flexDirection ?? 'column'};
    justify-content: ${props => props.justifyContent ? props.justifyContent : 'center'};
    align-items: ${props => props.alignItems ? props.alignItems : 'center'};
    max-width: ${setMobileView() ? '300px' : '550px'};
    margin: ${props => props.margin ?? ''};
    padding: ${props => props.padding ?? ''};
    border: ${props => props.border ?? ''};
    border-radius: ${props => props.borderRadius ?? ''};
`;

export const PrinterContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: end;
    width: 100%;
    margin: 0 20px;
`;

export const WordBreakContainer = styled.div`
    max-width: 300px;
    word-break: break-all;
    text-wrap: wrap;
    cursor: pointer;
`;

export const ButtonContainer = styled.div`
    margin: 20px 0;
`;

export const Title = styled.h2`

`;

export const Subtitle = styled.h4`
    text-align: ${props => props.textAlign ? props.textAlign : ''};
    margin: ${props => props.margin ? props.margin : ''};
    cursor: ${props => props.cursor ? props.cursor : ''};
`;

export const Text = styled.p`
    text-align: ${props => props.textAlign ? props.textAlign : ''};
    margin: ${props => props.margin ? props.margin : ''};
    cursor: ${props => props.cursor ? props.cursor : ''};
`;

export const Subtext = styled.h6`
    margin: ${props => props.margin ? props.margin : ''};
    padding: ${props => props.padding ? props.padding : ''};
`;

export const InputSubtext = styled.h6`
    max-width: 300px;
    margin: ${props => props.margin ? props.margin : ''};
    padding: ${props => props.padding ? props.padding : ''};
`;

export const Label = styled.label`

`;

export const Input = styled.input`
    width: ${props => props.width ? props.width : '300px'};
    margin-bottom: ${props => props.marginBottom ? props.marginBottom : '10px'};
    margin: ${props => props.marginBottom ? props.marginBottom : '5px'};
`;

export const Select = styled.select`
    margin: 10px 0;
`;

export const Option = styled.option`

`;

export const Textarea = styled.textarea`
    height: ${props => props.customHeight ? props.customHeight : '240px'};
    width: 300px;
    margin: ${props => props.margin ? props.margin : ' 0 0 10px 0'};
`;

export const Image = styled.img`
    width: 300px;
    height: 300px;
    margin-bottom: 20px;
`;

export const Table = styled.table`
    border: 1px solid;
    border-collapse: collapse;
    width: ${setMobileView() ? '300px' : ''};
    overflow: hidden; 
    textOverflow: ellipsis; 
    wordWrap: break-word;
    font-size: ${setMobileView() ? '12px' : ''};
`;

export const TableHeader = styled.thead`
    
`;

export const TableHead = styled.th`
    padding: ${setMobileView() ? '3px' : '8px'};
    border: 1px solid;
    cursor: ${props => props.cursor || ''};
`;

export const TableBody = styled.tbody`
    
`;

export const TableRow = styled.tr`
    border: 1px solid;
    cursor: ${props => props.cursor || ''};
`;

export const TableData = styled.td`
    padding: ${setMobileView() ? '3px' : '8px'};
    border: 1px solid;
    cursor: ${props => props.cursor || ''};
`;

export const Logo = styled.img`
    height: 200px;
    width: 200px;
`;

export const SmallButton = styled.button`
    margin: ${setMobileView() ? '10px' : '0 10px'};
    min-width: ${setMobileView() ? '90px' : '105px'};
    width: auto;
    height: 25px;
    letter-spacing: 0.5px;
    line-height: 25px;
    padding: 0 5px;
    font-size: ${setMobileView() ? '10px' : '12px'};
    background-color: #000;
    color: white;
    text-transform: uppercase;
    font-family: 'Open Sans Condensed';
    font-weight: bolder;
    border: 1px solid white;
    border-radius: 1px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    
    &:hover {
    background-color: #fff;
    color: #000;
    border: 1px solid #000;
    }
`;

export const DeleteButton = styled.button`
    margin: 20px 0;
    min-width: ${setMobileView() ? '105px' : '125px'};
    width: auto;
    height: 40px;
    letter-spacing: 0.5px;
    line-height: 40px;
    padding: 0 15px 0 15px;
    font-size: ${setMobileView() ? '10px' : '12px'};
    background-color: red;
    color: white;
    text-transform: uppercase;
    font-family: 'Open Sans Condensed';
    font-weight: bolder;
    border: 1px solid white;
    border-radius: 1px;
    cursor: pointer;
    display: flex;
    justify-content: center;

    &:hover {
    background-color: #fff;
    color: red;
    border: 1px solid red;
    }
`;

export const PaginationText = styled.h4`
    margin: 0 5px;
    padding: 5px;
`;

export const PaginationDots = styled.h4`
    margin: 0 5px;
    padding: 5px;
`;

export const PaginationContainer = styled.div`
    margin: 20px 0;
    display: flex;
    flex-direction: row;
`;

export const PaginationNumberContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 30px;
    width: 30px;
    text-align: center;
    cursor: ${props => props.cursor ?? 'pointer'};
    border: ${props => props.border ?? ''};
`;

export const AddImgPreviewEmpty = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 200px;
    width: 200px;
    border: 1px grey solid;
    border-radius: 3px;
`;

export const AddImgPreview = styled.img`
    height: 200px;
    width: 200px;
`;

export const AddImgBtn = styled.button`
    font-family: 'Open Sans Condensed';
    font-weight: bolder;
    text-transform: uppercase;
    color: #fff;
    background-color: #000;
    border: none;
    border-radius: 2px;
    margin: 10px 1px;
    width: 100%;
    height: 40px;
    width: 80px;
    padding: auto;

    &:hover {
        color: #000;
        background-color: #fff;
        border: #000 solid 1px;
    }
`;

export const AddImgLabel = styled.label`
    font-family: 'Open Sans Condensed';
    font-weight: bolder;
    text-transform: uppercase;
    color: #fff;
    background-color: #000;
    border: none;
    border-radius: 2px;
    margin: 10px 1px;
    width: 100%;
    text-align: center;
    height: 40px;
    width: 80px;
    padding: auto;

    &:hover {
        color: #000;
        background-color: #fff;
        border: #000 solid 1px;
    }
`;

export const AddImgInput = styled.input`
    display: none;
`;

export const Section = styled.div`
  width: 100%;
  margin-top: 2rem;
  padding-top: 1rem;
  border-top: 1px solid ${({ theme }) => theme.palette?.border || '#ddd'};
`;

export const CheckboxGroup = styled.div`
  display: flex;
  align-items: center;
  margin: 0.5rem 0;

  input[type='checkbox'] {
    margin-right: 0.5rem;
    transform: scale(1.2);
  }
`;

export const GridTwo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  width: 100%;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

export const ButtonGroup = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  margin-top: 2rem;
`;

export const HeaderWrapper = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem;
  height: 8vh;
  width: 100%;
  position: relative;
  z-index: 10;
  backdrop-filter: blur(4px);
  background-color: ${({ theme }) => theme.modePalette?.backgroundOpacityLight || 'rgba(255,255,255,0.8)'};
  transition: background-color 0.3s ease;
`;

export const SearchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`;

export const TabContainer = styled.div`
  display: flex;
  justify-content: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.border};
  background-color: ${({ theme }) => theme.palette.background.paper};
  padding: 0.5rem;
  width: 100%;
`;

export const TabSelector = styled.button`
  background-color: ${({ active }) => (active ? '#ccc' : 'transparent')};
  border: none;
  outline: none;
  cursor: pointer;
  padding: 10px 16px;
  font-size: 1rem;
  color: ${({ theme }) => theme.modePalette.text};
  transition: background-color 0.3s ease;

  :hover {
    background-color: ${({ active }) => (active ? '#ccc' : '#eee')};
  }
`;

export const MainTitle = styled.h2`
  text-align: center;
  font-size: ${setMobileView() ? '22px' : '32px'};
  margin-bottom: 1rem;
`;

export const BackLink = styled.h4`
  cursor: pointer;
  margin: 20px;
  color: ${({ theme }) => theme.modePalette.text};
  :hover {
    text-decoration: underline;
  }
`;

export const ThumbnailPreview = styled.img`
  height: 180px;
  width: 180px;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.layout?.borderRadius || '12px'};
  box-shadow: ${({ theme }) => theme.layout?.shadow?.sm || '0 1px 2px rgba(0,0,0,0.1)'};
`;

export const FieldGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: ${({ theme }) => theme.layout?.spacing?.md || '16px'};
  width: 100%;
`;

export const FieldLabel = styled.label`
  font-size: ${({ theme }) => theme.typography?.sizes?.small};
  font-weight: ${({ theme }) => theme.typography?.weights?.normal};
  margin-bottom: 0.5rem;
  color: ${({ theme }) => theme.palette?.text?.secondary};
`;

export const AddButton = styled.button`
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: bold;
  background: #f1f1f1;
  border: 1px solid #ccc;
  border-radius: 6px;
  cursor: pointer;

  &:hover {
    background: #e2e2e2;
  }

  svg {
    pointer-events: none;
  }
`;

export const Toggle = styled.label`
  position: relative;
  display: inline-block;
  width: 46px;
  height: 24px;

  input {
    opacity: 0;
    width: 0;
    height: 0;
  }

  span {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    border-radius: 24px;
    transition: 0.3s;
  }

  span:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    border-radius: 50%;
    transition: 0.3s;
  }

  input:checked + span {
    background-color: #007bff;
  }

  input:checked + span:before {
    transform: translateX(22px);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 120px;
  padding: 10px 14px;
  font-size: 1rem;
  font-family: inherit;
  border-radius: 6px;
  resize: vertical;
  transition: border-color 0.2s ease;

  &:focus {
    outline: none;
  }
`;

export const InfoBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px 24px;
  padding: 12px 0;
  border-bottom: 1px solid #e0e0e0;
  align-items: baseline;

  &:last-child {
    border-bottom: none;
  }
`;

export const InfoLabel = styled.span`
  font-weight: 600;
  color: #333;
  min-width: 120px;
`;

export const InfoValue = styled.span`
  color: #555;
  flex: 1;
`;